export enum InfoBoxState {
    DEFAULT = "default",
    NOEDIT = "noEdit",
    DELETEONLY = "deleteOnly",
    NEUTRAL = "neutral",
    NONE = "none",
    DISABLED = "disabled",
}
